import Mustache from "mustache";

class Template {
  constructor(config = {}) {
    this.config = {
      templatePath: "/templates/",
      templateExtension: "mustache",
      ...config,
    };

    this.templates = {};
  }

  set templatePath(path) {
    this.config.templatePath = path;

    return this;
  }

  get templatePath() {
    return this.config.templatePath;
  }

  set templateExtension(extension) {
    this.config.templateExtension = extension;

    return this;
  }

  get templateExtension() {
    return this.config.templateExtension;
  }

  async preload(name, url) {
    if (typeof this.templates[name] !== "undefined") {
      return this;
    }

    url =
      url ||
      `${this.config.templatePath.replace(
        /\/+$/,
        ""
      )}/${name}.${this.config.templateExtension.replace(/^\.+/, "")}`;

    let response;

    try {
      response = await fetch(url).then((response) => {
        if (response.status < 200 || response.status >= 400) {
          throw response;
        }

        return response.text();
      });
    } catch (error) {
      throw new Error("Template not found");
    }

    this.templates[name] = response;

    return this;
  }

  async render(name, data = {}) {
    await this.preload(name, data);

    return Mustache.render(this.templates[name], data);
  }

  async renderTo(name, data = {}, element) {
    if (typeof element === "undefined") {
      throw new Error('Missing required argument "element"');
    }

    if (!(element instanceof Element)) {
      throw new Error("Provided element is not a valid DOM element");
    }

    const template = await this.render(name, data);

    element.innerHTML = template;

    return this;
  }
}

export default Template;
